import React, { useState, useEffect, useRef } from "react";
import { Link, useNavigate } from "react-router-dom";
import {
  Navbar,
  Typography,
  Button,
  Card,
  CardBody,
  CardFooter,
  Accordion,
  AccordionHeader,
  AccordionBody,
  Dialog,
  Input,
  Textarea,
  IconButton,
} from "@material-tailwind/react";
import {
  ChevronRightIcon,
  ChevronLeftIcon,
  ArrowUpRightIcon,
  Bars3Icon,
  XMarkIcon,
} from "@heroicons/react/24/outline";
import Illustration1 from "./dashboard/images/Illustration_1.png";
import DecoLeft from "./dashboard/images/Deco-left.png";
import DecoRight from "./dashboard/images/Deco-right.png";
import IllustrateFAQ from "./dashboard/images/FAQ.jpg";
import BlogImg1 from "./dashboard/images/blog1_new.jpg";
import BlogImg2 from "./dashboard/images/blog2_new.jpg";
import BlogImg3 from "./dashboard/images/blog3_new.jpg";
import { api } from "api"; // Import your axios instance
import { ToastContainer, toast } from "react-toastify"; // Import ToastContainer and toast
import "react-toastify/dist/ReactToastify.css"; // Import the CSS for styling

import st1 from "./dashboard/images/st1.png";
import st2 from "./dashboard/images/st2.png";
import pm1 from "./dashboard/images/pm1.png";
import pm2 from "./dashboard/images/pm2.png";
import gm1 from "./dashboard/images/gm1.png";
import gm2 from "./dashboard/images/gm2.png";
import str1 from "./dashboard/images/str1.png";
import str2 from "./dashboard/images/str2.png";
import hr1 from "./dashboard/images/hr1.png";
import hr2 from "./dashboard/images/hr2.png";
import cl1 from "./dashboard/images/cl1.png";
import cl2 from "./dashboard/images/cl2.png";
import landingPage from "./dashboard/images/landingpagehero.png";

// import IllustrationFreeOval from './dashboard/images/Illustration_Free_Oval.png';
// import img2 from "./AECP-LP/Rectangle 4333.png";
// import img3 from "./AECP-LP/Illustration_Free_Oval.png";
// import img4 from "./AECP-LP/Section.png";

// Dummy data for features, FAQ, and blogs
const featuresList = [
  {
    title: "HR Managers",
    whatItIs: "HR teams benefit from centralized workforce management:",
    content: [
      "HR Dashboard: A unified view of HR metrics like attendance trends, headcount, etc.",
      "Employee Profile Management: Maintain comprehensive staff profiles and records.",
      "Leave Requests & Approvals: Manage employee leave requests with approval workflows.",
      "Attendance Tracking: Get accurate attendance logs integrated with payroll systems.",
      "Data-Driven Leave Analytics: Understand leave patterns for better workforce planning.",
      "Timesheet Management: Track work hours and overtime for project-based billing.",
    ],
    img1 : hr1,
    img2 : hr2,
    
    //impact:"Ensures accurate billing, payroll integration, and time analysis for resource optimization."
  },
  {
    title: "Senior Leadership / General Managers",
    whatItIs: "Top-level executives get strategic oversight:",
    content: [
      "Cross-Module Dashboard Access: One view for all modules (Projects, HR, Inventory, etc.).",
      "Macro Management Insights: Understand trends, issues, and strategic bottlenecks.",
      "Comprehensive Data: View total clients, active projects, employee counts, material usage, and finances.",
      "Real-Time Notifications: Stay informed on key updates without micro-managing.",
      "360° Operations Oversight: End-to-end visibility across departments and functions.",
    ],
    img1 : gm1,
    img2 : gm2,
    // impact:"Simplifies workforce management and speeds up HR operations."
  },
  {
    title: "Project Managers",
    whatItIs:
      "AECP empowers Project Managers to maintain control over every aspect of the project lifecycle:",
    content: [
      "Project & Task Management: Easily assign, monitor, and track progress across multiple tasks and teams.",
      "Daily Calendar Management: Set deadlines, receive due date alerts, and plan project phases effectively",
      "Monthly Report Generation: Auto-generate reports to track progress, productivity, and timelines.",
      "Material Requests & Resource Allocation: Submit material/tool requests and assign resources efficiently.",
      "Real-Time Notifications & Alerts: Stay updated on approvals, delays, or urgent changes.",
      "Leave Management Coordination: Sync team availability with project schedules.",
    ],
    img1 : pm1,
    img2 : pm2,
    //impact:"Keeps everyone aligned with real-time updates, ensuring accountability and progress visibility."
  },
  {
    title: "Site Managers",
    whatItIs:
      "For on-ground execution, AECP supports Site Managers with operational tools:",
    content: [
      "Task Assignment & Tracking: Allocate site tasks and monitor completion status in real time.",
      "Attendance & Leave Management: Track workforce attendance and manage leave approvals.",
      "Request Management: Handle material, tool, and manpower requests efficiently.",
      "Daily Calendar Updates: Plan site milestones, delivery schedules, and inspections.",
      "Monthly Report Generation: Auto-generate reports to track progress, productivity, and timelines.",
    ],
    img1 : st1,
    img2 : st2,
    //impact:"Empowers managers to take quick, informed actions."
  },

  {
    title: "Store Managers",
    whatItIs:
      "AECP simplifies inventory and warehouse operations for Store Managers:",
    content: [
      "Real-time Inflow & Outflow Tracking: Log materials coming in and going out.",
      "Inventory & Stock Level Monitoring: Prevent shortages or overstocking.",
      "Request & Issue Management: Process material/tool requests quickly.",
      "Wastage Recording & Reporting: Identify and minimize material losses.",
      "Low Stock & Maintenance Alerts: Get notified when stock is low or items need repair.",
      "Calendar View: Plan restocking, audits, and delivery schedules efficiently.",
    ],
    img1 : str1,
    img2 : str2,
    // impact:" Makes HR operations seamless and error-free, improving employee satisfaction."
  },
  {
    title: "Clients / Project Owners",
    whatItIs:
      "AECP enhances client satisfaction through transparency and control:",
    content: [
      "Client Management Portal: Dedicated interface for client engagement.",
      "Material Usage & Budget Tracking: Real-time visibility into resource utilization.",
      "Downloadable Reports: Easily export data and insights",
      "Project Progress Tracking: Monitor timelines, deliverables, and outcomes.",
      "Improved Communication: Centralized updates reduce the need for constant follow-ups.",
    ],
    img1 : cl1,
    img2 : cl2,
    // impact:"Centralizes team communication, avoids miscommunication, and increases responsiveness."
  },

  {
    title: "Procurement & Inventory Teams",
    whatItIs: "Ensure smooth procurement cycles and inventory management:",
    content: [
      "Material Management: Track usage, availability, and delivery of materials.",
      "Order Management: Filter orders by status, supplier, or material type.",
      "Supplier Overview: Access supplier information, product specs, and performance history.",
      "Stock Maintenance: Monitor inventory levels across locations.",
      "Wastage Analysis: Understand where materials are being lost or misused.",
    ],
    img1 : str1,
    img2 : str2,
    // impact:"Simplifies workforce management and speeds up HR operations."
  },
];

const faqs = [
  {
    question: "What is AECP, and who is it designed for?",
    answer:
      "AECP (Architecture, Engineering & Construction Platform) is a role-based project management solution designed for construction and infrastructure companies. It caters to Project Managers, Site Managers, HR, Store Managers, Procurement Teams, Clients, and Senior Leadership.",
  },
  {
    question:
      "How does AECP help Project Managers streamline daily operations?",
    answer:
      "AECP offers project and task management, calendar alerts, monthly reporting, material/resource allocation, and a macro dashboard. These features help managers plan, track, and execute projects efficiently.",
  },
  {
    question: "Can Site Managers track equipment and material usage on-site?",
    answer:
      "Yes, Site Managers can use AECP to track equipment maintenance, monitor stock and wastage, manage requests for materials/tools, and update daily site calendars.",
  },
  {
    question: "What HR functionalities are included in AECP?",
    answer:
      "HR Managers can manage employee profiles, leave and attendance, timesheets, HR analytics, and approvals using a centralized dashboard with automated notifications.",
  },
  {
    question: "Does AECP support inventory and procurement management?",
    answer:
      "Absolutely. AECP enables Store Managers and Procurement Teams to track real-time material inflow/outflow, manage stock levels, issue requests, analyze wastage, and view procurement schedules.",
  },
  {
    question:
      "What kind of transparency does AECP provide to clients or project owners?",
    answer:
      "Clients get access to a dedicated portal with real-time updates on material usage, budgets, progress tracking, and downloadable reports—enhancing communication and transparency.",
  },
  {
    question:
      "Can senior leadership monitor multiple projects across different teams?",
    answer:
      "Yes, AECP provides a 360° dashboard that offers cross-module insights, including clients, projects, employees, materials, and financials—enabling data-driven decision-making.",
  },
  {
    question: "How does AECP handle notifications and alerts?",
    answer:
      "The platform features real-time notifications for due dates, approvals, low stock levels, maintenance schedules, and important updates across roles.",
  },
  {
    question: "How does AECP help reduce material wastage?",

    answer:
      "Through detailed stock tracking, wastage reporting, and analytics, AECP enables teams to identify inefficiencies and optimize resource usage, ultimately reducing losses.",
  },
  {
    question: "Is there a centralized calendar system in AECP?",
    answer:
      "Yes, AECP offers a calendar view for all roles, allowing users to manage milestones, deliveries, restocking schedules, and daily tasks effectively.",
  },
];

const blogs = [
  {
    id: 1,
    title: "AECP's Solution to Boosting Efficiency in Growing Businesses",
    category: "Product",
    image: BlogImg1,
    description:
      "For businesses experiencing growth, one of the most significant challenges is maintaining project efficiency. As teams expand...",
  },
  {
    id: 2,
    title: "How AECP's Workflow Automation Supports Expansion",
    category: "Product",
    image: BlogImg2,
    description:
      "As businesses expand, they often face an influx of new processes, larger teams, and increasingly complex workflows...",
  },
  {
    id: 3,
    title: "Here's How AECP Bridges the Gap Across Time Zones",
    category: "Product",
    image: BlogImg3,
    description:
      "The construction and design industry has long been known for its onsite work, with teams collaborating in person on project sites...",
  },
];

const FEATURES_PER_PAGE = 7;
const FAQS_PER_PAGE = 4;

export default function LandingPage() {
  const [activeFeature, setActiveFeature] = useState(0);
  const [featurePage, setFeaturePage] = useState(0);
  const [faqPage, setFaqPage] = useState(0);
  const [openFaq, setOpenFaq] = useState(null);
  const [showDemoModal, setShowDemoModal] = useState(false);
  const [contactForm, setContactForm] = useState({
    name: "",
    email: "",
    message: "",
  });
  const navigate = useNavigate();
  const [isScrolled, setIsScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const featureCardRef = useRef(null);
  const [featureImageIndex, setFeatureImageIndex] = useState(0);

  const featureImages = [
    featuresList[activeFeature].img1,
    featuresList[activeFeature].img2,
    ...(featuresList[activeFeature].img3 ? [featuresList[activeFeature].img3] : [])
  ];

  useEffect(() => {
    // Dynamically add Tailwind CSS
    const link = document.createElement("link");
    link.rel = "stylesheet";
    link.href = "/tailwind.css";
    link.id = "tailwindcss";
    document.head.appendChild(link);

    // Cleanup: remove Tailwind CSS when component unmounts
    return () => {
      const existing = document.getElementById("tailwindcss");
      if (existing) existing.remove();
    };
  }, []);

  useEffect(() => {
    const onScroll = () => setIsScrolled(window.scrollY > 20);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  // Features Pagination
  const totalFeaturePages = Math.ceil(featuresList.length / FEATURES_PER_PAGE);
  const paginatedFeatures = featuresList.slice(
    featurePage * FEATURES_PER_PAGE,
    (featurePage + 1) * FEATURES_PER_PAGE
  );

  // FAQ Pagination
  const totalFaqPages = Math.ceil(faqs.length / FAQS_PER_PAGE);
  const paginatedFaqs = faqs.slice(
    faqPage * FAQS_PER_PAGE,
    (faqPage + 1) * FAQS_PER_PAGE
  );

  // Modal form handlers
  const handleContactChange = (e) => {
    setContactForm({ ...contactForm, [e.target.name]: e.target.value });
  };

  const handleContactSubmit = async (e) => {
    e.preventDefault();

    try {
      const response = await api.post("landingPageContact.php", {
        name: contactForm.name,
        email: contactForm.email,
        message: contactForm.message,
      });

      if (response.data.status === "success") {
        toast.success("Your message has been sent successfully!"); // Show success toast
        setContactForm({ name: "", email: "", message: "" }); // Reset form
      } else {
        toast.error("Error sending your message."); // Show error toast
      }
    } catch (error) {
      console.error("Error submitting the contact form:", error);
      toast.error("An error occurred while sending your message."); // Show error toast
    }
  };

  // Helper to scroll to card on mobile
  const handleFeatureClick = (idx) => {
    setActiveFeature(idx + featurePage * FEATURES_PER_PAGE);
    if (window.innerWidth < 768 && featureCardRef.current) {
      setTimeout(() => {
        featureCardRef.current.scrollIntoView({
          behavior: "smooth",
          block: "start",
        });
      }, 100); // slight delay to ensure card content updates
    }
  };

  // Helper to scroll to section with navbar offset
  const handleNavClick = (e, targetId) => {
    e.preventDefault();
    const element = document.getElementById(targetId);
    if (element) {
      const navbarHeight = 100; // Approximate navbar height
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - navbarHeight;

      window.scrollTo({
        top: offsetPosition,
        behavior: "smooth",
      });
    }
  };

  return (
    <div className="bg-[#ffffff] min-h-screen flex flex-col font-sans overflow-x-hidden">
      <ToastContainer />
      {/* Sticky WhatsApp Icon */}
      <div
        className="fixed bottom-8 right-1 flex flex-col gap-4"
        style={{ zIndex: 1000 }}
      >
        {/* WhatsApp Icon */}
        <a
          href="https://wa.me/+971545003544"
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Chat on WhatsApp"
          className="bg-[#25D366] rounded-[20%] w-[60px] h-[60px] flex items-center justify-center shadow-lg hover:scale-110 transition-transform duration-300"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="34"
            height="34"
            viewBox="0 0 32 32"
            fill="white"
          >
            <path d="M16 3C9.373 3 4 8.373 4 15c0 2.65.87 5.1 2.36 7.1L4 29l7.18-2.32C13.13 27.56 14.53 28 16 28c6.627 0 12-5.373 12-12S22.627 3 16 3zm0 22c-1.29 0-2.54-.25-3.7-.74l-.26-.11-4.26 1.38 1.39-4.14-.17-.27C7.25 18.01 7 16.52 7 15c0-5.06 4.13-9.18 9.19-9.18 5.06 0 9.19 4.12 9.19 9.18 0 5.06-4.13 9.18-9.19 9.18zm5.13-6.42c-.28-.14-1.65-.81-1.9-.9-.25-.09-.43-.14-.61.14-.18.28-.7.9-.86 1.08-.16.18-.32.2-.6.07-.28-.14-1.18-.44-2.25-1.41-.83-.74-1.39-1.65-1.56-1.93-.16-.28-.02-.43.12-.57.13-.13.28-.33.42-.5.14-.17.18-.28.28-.46.09-.18.05-.34-.02-.48-.07-.14-.61-1.47-.84-2.01-.22-.53-.45-.46-.62-.47-.16-.01-.34-.01-.52-.01-.18 0-.48.07-.73.34-.25.27-.97.95-.97 2.32 0 1.37.99 2.7 1.13 2.89.14.18 1.95 2.98 4.73 4.06.66.28 1.18.45 1.58.58.66.21 1.26.18 1.73.11.53-.08 1.65-.67 1.89-1.32.23-.65.23-1.2.16-1.32-.07-.12-.25-.19-.53-.33z" />
          </svg>
        </a>

        {/* Email Icon */}
        {/* <a
          href="mailto:anand@swifterz.ae"
          aria-label="Send Email"
          className="bg-[#EA4335] rounded-[20%] w-[60px] h-[60px] flex items-center justify-center shadow-lg hover:scale-110 transition-transform duration-300"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="34"
            height="34"
            viewBox="0 0 24 24"
            fill="white"
          >
            <path d="M20 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z" />
          </svg>
        </a> */}

<button
  onClick={() => {
    const emailLink = document.createElement('a');
    emailLink.href = "mailto:anand@swifterz.ae";
    emailLink.click();
  }}
  aria-label="Send Email"
  className="bg-[#EA4335] rounded-[20%] w-[60px] h-[60px] flex items-center justify-center shadow-lg hover:scale-110 transition-transform duration-300"
>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="34"
    height="34"
    viewBox="0 0 24 24"
    fill="white"
  >
    <path d="M20 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z" />
  </svg>
</button>


      </div>
      {/* Sticky Glassmorphism Header */}
      <Navbar
        className={`fixed top-0 left-0 w-full z-50 transition-all duration-300 py-0  ${
          isScrolled
            ? "backdrop-blur-md bg-gray-100 shadow-md text-black"
            : " bg-gray-100 text-black"
        } border-0`}
        style={{ border: "none" }}
        blurred={true}
        fullWidth={true}
        shadow={false}
      >
        <div className="container mx-auto flex items-center justify-between ">
          <img
            src={require("./dashboard/images/AECP_logo.png")}
            alt="AECP Logo"
            style={{ height: "90px", width: "auto", marginRight: "16px" }}
          />
          {/* LOGO left-aligned */}
          <div className="flex-1 flex items-center">
            {/* <Typography
                          variant="h5"
                          className={`text-white font-bold tracking-wider ${
                            isScrolled ? "text-black" : "text-white"
                          }`}
                        >
                          LOGO
                        </Typography> */}
          </div>
          {/* Hamburger Icon for mobile */}
          <button
            className="lg:hidden text-black focus:outline-none"
            onClick={() => setMobileMenuOpen(true)}
            aria-label="Open menu"
          >
            <Bars3Icon className="w-7 h-7" />
          </button>
          {/* Nav links centered (desktop only) */}
          <div
            className={`flex-1 hidden lg:flex justify-center gap-8 ${
              isScrolled ? "text-black" : "text-black"
            }`}
          >
            {["About Us", "Features", "Blogs", "FAQs", "Contact Us"].map(
              (item, idx) => {
                const targetId = item.toLowerCase().replace(/ /g, "");
                return (
                  <a
                    key={item}
                    href={`#${targetId}`}
                    onClick={(e) => handleNavClick(e, targetId)}
                    className={`text-black font-medium hover:text-[#E08681] transition whitespace-nowrap cursor-pointer ${
                      isScrolled ? "text-black" : "text-black"
                    }`}
                  >
                    {item}
                  </a>
                );
              }
            )}
          </div>
          {/* Login button right-aligned and smaller (desktop only) */}
          <div className="flex-1 hidden lg:flex justify-end gap-2">
            <Button
              className="px-3 py-1.5 rounded-md font-semibold text-sm shadow-none min-w-0 h-9 bg-[#E08681]"
              onClick={() => navigate("/company-register")}
            >
              Register
            </Button>
            <Button
              className="px-4 py-1.5 rounded-md font-semibold text-sm shadow-none min-w-0 h-9 bg-[#E08681]"
              style={{ minWidth: "80px" }}
              onClick={() => navigate("/login")}
            >
              Login
            </Button>
          </div>
        </div>
        {/* Mobile Menu Drawer */}
        {mobileMenuOpen && (
          <div
            className="fixed inset-0 z-[999] bg-black/40 lg:hidden"
            onClick={() => setMobileMenuOpen(false)}
          >
            <div
              className="absolute top-0 right-0 w-4/5 max-w-xs h-full bg-pink-100 shadow-lg flex flex-col p-4  gap-6 overflow-y-auto"
              onClick={(e) => e.stopPropagation()}
              style={{ minHeight: "100vh" }}
            >
              <div className="flex justify-between items-center mb-4">
                <img
                  src={require("./dashboard/images/AECP_logo.png")}
                  alt="AECP Logo"
                  style={{ height: "90px", width: "auto", marginRight: "16px" }}
                />
                <button
                  onClick={() => setMobileMenuOpen(false)}
                  aria-label="Close menu"
                >
                  <XMarkIcon className="w-7 h-7 text-white" />
                </button>
              </div>
              <nav className="flex flex-col gap-4 items-center">
                {["About Us", "Features", "Blogs", "FAQs", "Contact Us"].map(
                  (item, idx) => {
                    const targetId = item.toLowerCase().replace(/ /g, "");
                    return (
                      <a
                        key={item}
                        href={`#${targetId}`}
                        onClick={(e) => {
                          handleNavClick(e, targetId);
                          setMobileMenuOpen(false);
                        }}
                        className="text-white font-medium text-lg py-2 px-2 rounded hover:bg-[#13c9a7]/20 transition cursor-pointer"
                      >
                        {item}
                      </a>
                    );
                  }
                )}
              </nav>
              <button
                className="mt-4 w-full bg-[#E08681] text-white font-semibold rounded-md py-2"
                onClick={() => {
                  setMobileMenuOpen(false);
                  navigate("/company-register");
                }}
              >
                Register
              </button>
              <button
                className="mt-4 w-full bg-[#E08681] text-white font-semibold rounded-md py-2"
                onClick={() => {
                  setMobileMenuOpen(false);
                  navigate("/login");
                }}
              >
                Login
              </button>
            </div>
          </div>
        )}
      </Navbar>

      {/* Header background and hero */}
      <header id="aboutus" className="relative  pt-24 pb-10 overflow-hidden rounded-b-5xl" style={{color: "white"}}>
        <div className="container mx-auto flex flex-col-reverse md:flex-row items-center justify-between px-4 md:px-8 gap-8 md:gap-0">
          {/* Left: Text Content */}
          <div className="flex-1 flex flex-col items-start justify-center text-left md:pr-8">
            <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold text-[#23235f] mb-4 leading-tight">
              AECP unifies labor, materials, and operations for seamless
              <br />
              construction management.
            </h1>
            <p className="text-gray-600 text-base md:text-lg mb-6 max-w-md">
              Managing labor, tracking progress, sourcing materials, and keeping
              teams aligned shouldn't be this hard.
            </p>
            <button
              className="bg-[#E08681] hover:bg-[#d06c6a] text-white font-semibold rounded-md px-6 py-3 transition-colors duration-200 shadow-md"
              onClick={() => navigate("/demo-register")}
            >
              Request a Demo
            </button>
          </div>
          {/* Right: Illustration */}
          <div className="flex-1 flex items-center justify-center md:mb-0">
            <img
              src={landingPage}
              alt="hero"
              className="rounded-xl object-cover shadow-3xl w-full max-w-4xl"
              style={{ minHeight: '500px' }}
            />
          </div>
        </div>
      </header>

      {/* Features Section */}
      <section id="features" className="container mx-auto py-10 px-4 md:px-4 ">
        <Typography
          variant="h2"
          className="font-bold text-center mb-10 text-[#23235f]"
        >
          We provide excellent features
        </Typography>
        <div className="flex flex-col md:flex-row gap-8 items-start">
          <div className="flex-1 flex flex-col gap-4 w-full max-w-md mx-auto md:mx-0 z-20">
            {paginatedFeatures.map((feature, idx) => (
              <button
                key={feature.title}
                type="button"
                className={`w-full text-left px-6 py-4 rounded-xl font-semibold flex items-center justify-between text-base transition-all duration-200
                  ${
                    activeFeature === idx + featurePage * FEATURES_PER_PAGE
                      ? "shadow-lg"
                      : "hover:bg-[#fbeaea]"
                  }
                  bg-[#fdf6f3]
                `}
                style={{
                  borderWidth: "2px",
                  borderStyle: "solid",
                  borderColor: "transparent",
                  borderRadius: "1rem",
                  background:
                    "linear-gradient(#fdf6f3, #fdf6f3) padding-box, linear-gradient(to right, #E08681, #fff) border-box",
                  boxShadow:
                    activeFeature === idx + featurePage * FEATURES_PER_PAGE
                      ? "0 4px 24px 0 rgba(207,97,124,0.07)"
                      : undefined,
                }}
                onClick={() => handleFeatureClick(idx)}
              >
                <span className="font-semibold text-[#23235f]">
                  {feature.title}
                </span>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  strokeWidth={2}
                  stroke="#23235f"
                  className="w-5 h-5 ml-2"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M9 5l7 7-7 7"
                  />
                </svg>
              </button>
            ))}
            {/* Features Pagination */}
            {/* <div className="flex flex-row justify-end items-center gap-2 mt-6">
              <button
                onClick={() => setFeaturePage((p) => Math.max(0, p - 1))}
                disabled={featurePage === 0}
                className={`w-9 h-9 flex items-center justify-center rounded-full text-xl transition-colors border-0 focus:outline-none ${
                  featurePage === 0
                    ? "bg-gray-300 text-white cursor-not-allowed"
                    : "bg-gradient-to-r from-[#d1bfa3] to-[#fbe6c2] text-white hover:opacity-90"
                }`}
              >
                <ChevronLeftIcon className="w-5 h-5" />
              </button>
              <button
                onClick={() =>
                  setFeaturePage((p) => Math.min(totalFeaturePages - 1, p + 1))
                }
                disabled={featurePage === totalFeaturePages - 1}
                className={`w-9 h-9 flex items-center justify-center rounded-full text-xl transition-colors border-0 focus:outline-none ${
                  featurePage === totalFeaturePages - 1
                    ? "bg-gray-300 text-white cursor-not-allowed"
                    : "bg-gradient-to-r from-[#d1bfa3] to-[#fbe6c2] text-white hover:opacity-90"
                }`}
              >
                <ChevronRightIcon className="w-5 h-5" />
              </button>
            </div> */}
          </div>
          {/* DecoLeft - only visible on large screens and above */}
          <div className="absolute top-[80%] z-10 xl:top-[80%] 2xl:top-[180%] lg:left-[1%] hidden lg:block">
            <img
              src={DecoLeft}
              alt="Deco-left"
              className="w-[80%] h-full object-cover"
            />
          </div>
          {/* DecoRight - only visible on large screens and above */}
          <div className="absolute w-[20%] lg:top-[20%] xl:top-[60%] lg:right-0 hidden lg:block">
            <img
              src={DecoRight}
              alt="Deco-right"
              className="w-full h-full object-cover"
            />
          </div>
          <Card
            ref={featureCardRef}
            className="flex-1 rounded-2xl shadow-[16px_-18px_20px_-1px_rgba(0,_0,_0,_0.1)]  p-4 md:p-8 min-h-[260px] bg-black"
            style={{
              backgroundColor: "white",
              zIndex: 10,
              position: "relative",
            }}
          >
            {/* <Typography variant="h5" className="font-bold mb-2 text-[#23235f]">
              {featuresList[activeFeature].title}
            </Typography> */}
            <Typography variant="h6" className="font-normal mb-2 text-gray-700">
              {featuresList[activeFeature].whatItIs}
            </Typography>
            <Typography variant="h6" className="font-bold mb-2 text-[#23235f]">
              Solves:
            </Typography>
            <ul className="list-disc pl-5 text-gray-700 space-y-1">
              {featuresList[activeFeature].content.map((item, i) => (
                <li key={i}>{item}</li>
              ))}
            </ul>
            <Typography variant="h6" className="font-normal mb-2 text-gray-700">
              {featuresList[activeFeature].impact}
            </Typography>
            {/* Carousel Section */}
            <div className="w-full flex justify-center mt-6">
              <div className="relative w-full max-w-2xl flex items-center justify-center">
                <button
                  className="absolute left-0 z-10 bg-white/80 rounded-full p-2 shadow hover:bg-[#E08681] hover:text-white transition"
                  onClick={() => setFeatureImageIndex((prev) => (prev === 0 ? featureImages.length - 1 : prev - 1))}
                  aria-label="Previous image"
                  style={{ top: '50%', transform: 'translateY(-50%)' }}
                >
                  <svg width="32" height="32" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" d="M15 19l-7-7 7-7"/></svg>
                </button>
                <img
                  src={featureImages[featureImageIndex]}
                  alt={`Feature ${activeFeature + 1} - ${featureImageIndex + 1}`}
                  className="rounded-xl object-cover w-full h-72 md:h-96 shadow border-2 border-gray-200 mx-auto"
                  style={{ maxWidth: '600px', minHeight: '280px', background: '#f5f5f5' }}
                />
                <button
                  className="absolute right-0 z-10 bg-white/80 rounded-full p-2 shadow hover:bg-[#E08681] hover:text-white transition"
                  onClick={() => setFeatureImageIndex((prev) => (prev === featureImages.length - 1 ? 0 : prev + 1))}
                  aria-label="Next image"
                  style={{ top: '50%', transform: 'translateY(-50%)' }}
                >
                  <svg width="32" height="32" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" d="M9 5l7 7-7 7"/></svg>
                </button>
              </div>
            </div>
          </Card>
        </div>
        {/* Register Button */}
        <div className="flex justify-center items-center">
          <button
            className=" md:px-10 px-2  bg-[#E08681] hover:bg-[#d06c6a] text-white font-semibold rounded-lg py-3 text-lg shadow transition-all duration-200"
            onClick={() => navigate("/company-register")}
          >
            Register to get started
          </button>
        </div>
      </section>

      {/* FAQ Section with Pagination */}
      <section id="faqs" className="bg-[#e2e2e4] py-10 px-2 md:px-4">
        <div className="container mx-auto flex flex-col md:flex-row gap-8 items-center">
          {/* FAQ Illustration */}
          <img
            src={IllustrateFAQ}
            alt="faq"
            className="w-[42%] rounded-xl shadow hidden md:block"
          />
          {/* FAQ Content */}
          <div className="flex-1 w-full">
            <Typography
              variant="h4"
              className="font-bold mb-2 text-4xl text-[#E08681]"
            >
              Frequently Asked Questions
            </Typography>
            <Typography className="mb-2 text-gray-500 text-base">
              Find answers to your most common questions and learn how AECP can
              streamline your business operations, boost efficiency, and enhance
              collaboration.
            </Typography>
            <div className="p-4">
              <div className="border-b-2 border-gray-600 mb-2" />
              {paginatedFaqs.map((faq, idx) => (
                <div key={idx}>
                  <button
                    className="w-full flex justify-between items-center py-4 focus:outline-none text-left"
                    onClick={() => setOpenFaq(openFaq === idx ? null : idx)}
                  >
                    <div>
                      <span className="font-semibold text-[#23235f] text-base">
                        {faq.question}
                      </span>
                      {openFaq === idx && (
                        <div className="mt-2 text-gray-600 text-sm leading-relaxed">
                          {faq.answer}
                        </div>
                      )}
                    </div>
                    <span className="ml-4 text-2xl text-gray-600 font-bold">
                      {openFaq === idx ? "-" : "+"}
                    </span>
                  </button>
                  {idx !== paginatedFaqs.length - 1 && (
                    <hr className="border-t border-gray-500" />
                  )}
                </div>
              ))}
              {/* Pagination */}
              <div className="flex justify-end items-center gap-2 mt-6">
                <button
                  onClick={() => setFaqPage((p) => Math.max(0, p - 1))}
                  disabled={faqPage === 0}
                  className={`w-9 h-9 flex items-center justify-center rounded-full border text-xl transition-colors ${
                    faqPage === 0
                      ? "bg-gray-200 text-gray-400 cursor-not-allowed"
                      : "bg-gradient-to-r from-[#d1bfa3] to-[#fbe6c2] text-white hover:opacity-90"
                  }`}
                >
                  <ChevronLeftIcon className="w-5 h-5" />
                </button>
                <button
                  onClick={() =>
                    setFaqPage((p) => Math.min(totalFaqPages - 1, p + 1))
                  }
                  disabled={faqPage === totalFaqPages - 1}
                  className={`w-9 h-9 flex items-center justify-center rounded-full border text-xl transition-colors ${
                    faqPage === totalFaqPages - 1
                      ? "bg-gray-200 text-gray-400 cursor-not-allowed"
                      : "bg-gradient-to-r from-[#d1bfa3] to-[#fbe6c2] text-white hover:opacity-90"
                  }`}
                >
                  <ChevronRightIcon className="w-5 h-5" />
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Blog/News Section */}
      <section id="blogs" className="container mx-auto py-10 px-2 md:px-4">
        <Typography
          variant="h3"
          className="font-bold text-left mb-10 text-[#23235f]"
        >
          Latest Blog & News
        </Typography>
        <div className=" grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
          {blogs.map((blog) => (
            <div
              key={blog.id}
              className="bg-[#ffffff] py-3 px-3 rounded-xl shadow-lg transition-transform duration-200 hover:-translate-y-1 hover:shadow-lg cursor-pointer"
              // onClick={() => navigate(`/blog/${idx + 1}`)}
            >
              <img
                src={blog.image}
                alt={blog.title}
                className="rounded-xl mb-4 w-full h-48 object-cover"
              />
              <span className="text-sm font-semibold mb-1 block text-[#E08681]">
                {blog.category}
              </span>
              <div className="flex items-center mb-2">
                <Link to={`/blog/${blog.id}`}>
                  <Typography className="text-lg font-bold">
                    {blog.title}
                  </Typography>
                </Link>
                <ArrowUpRightIcon className="w-5 h-5 text-[#23235f] ml-2" />
              </div>
              <span className="text-gray-500 text-sm">{blog.description}</span>
            </div>
          ))}
        </div>
      </section>

      {/* Contact Section */}
      <section id="contactus" className="bg-[#ffffff] py-10 px-2 md:px-4">
        <div className="container mx-auto grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-12 items-start">
          {/* Left: Get in Touch */}
          <div className="mb-8 md:mb-0">
            <h2 className="text-2xl md:text-3xl font-extrabold text-[#000000] mb-2">
              Get in Touch
            </h2>
            <p className="text-gray-400  max-w-xs">
              We appreciate each customer and we are proud that 60% of clients
              come back to work with us again.
            </p>
            <Button
              className="px-3 py-1.5 rounded-md font-semibold text-sm shadow-none min-w-0 h-9 bg-[#E08681] mt-4F mb-4"
              onClick={() => navigate("/company-register")}
            >
              Register
            </Button>
            <div className="mb-4">
              <a
                href="tel:+919894055835"
                className="block font-bold text-[#23235f] mb-1 flex items-center gap-2 hover:text-[#E08681] transition-colors"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  viewBox="0 0 24 24"
                  fill="currentColor"
                  className="text-[#E08681]"
                >
                  <path d="M20 10.999h2C22 5.869 18.127 2 13.996 2v2C17.042 4 20 6.958 20 10.999z"/>
                  <path d="M13 8v2c1.103 0 2 .897 2 2h2c0-2.206-1.794-4-4-4zm6.422 10.443a1.001 1.001 0 0 0-1.391.043l-2.393 2.461c-.576-.11-1.734-.471-2.926-1.66-1.192-1.193-1.553-2.354-1.66-2.926l2.459-2.394a1 1 0 0 0 .043-1.391L6.859 3.513a1 1 0 0 0-1.391-.087l-2.17 1.861a1 1 0 0 0-.29.649c-.015.25-.301 6.172 4.291 10.766C11.305 20.707 16.323 21 17.705 21c.202 0 .326-.006.359-.008a.992.992 0 0 0 .648-.291l1.86-2.171a1 1 0 0 0-.086-1.391l-4.064-3.696z"/>
                </svg>
                +91 98940 55835
              </a>
              <a
                href="tel:+971545003544"
                className="block font-bold text-[#23235f] mb-1 flex items-center gap-2 hover:text-[#E08681] transition-colors"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  viewBox="0 0 24 24"
                  fill="currentColor"
                  className="text-[#E08681]"
                >
                  <path d="M20 10.999h2C22 5.869 18.127 2 13.996 2v2C17.042 4 20 6.958 20 10.999z"/>
                  <path d="M13 8v2c1.103 0 2 .897 2 2h2c0-2.206-1.794-4-4-4zm6.422 10.443a1.001 1.001 0 0 0-1.391.043l-2.393 2.461c-.576-.11-1.734-.471-2.926-1.66-1.192-1.193-1.553-2.354-1.66-2.926l2.459-2.394a1 1 0 0 0 .043-1.391L6.859 3.513a1 1 0 0 0-1.391-.087l-2.17 1.861a1 1 0 0 0-.29.649c-.015.25-.301 6.172 4.291 10.766C11.305 20.707 16.323 21 17.705 21c.202 0 .326-.006.359-.008a.992.992 0 0 0 .648-.291l1.86-2.171a1 1 0 0 0-.086-1.391l-4.064-3.696z"/>
                </svg>
                +971 54 500 3544
              </a>

              <a
                href="mailto:anand@swifterz.ae"
                className="block font-bold text-[#23235f] flex items-center gap-2 hover:text-[#E08681] transition-colors"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  viewBox="0 0 24 24"
                  fill="currentColor"
                  className="text-[#E08681]"
                >
                  <path d="M20 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z"/>
                </svg>
                anand@swifterz.ae
              </a>
            </div>
            <div className="text-center mt-3 p-3 bg-[#E08681]/20 border border-[#E08681]/30 rounded-lg text-sm shadow-lg">
              <span className="font-medium text-black">💡 </span>
              <span className="text-black">
                If your email app didn't open, please send your query to{" "}
                <a href="mailto:anand@swifterz.ae" className="text-[#E08681] underline font-semibold">
                  anand@swifterz.ae
                </a>{" "}
                or use our contact form.
              </span>
            </div>
            <hr className="my-2 border-gray-200" />
            <div className="mb-2 font-bold text-[#0a0a0a]">Find Us on Map</div>
            {/* <div className="text-gray-400 mb-2">
              Via Salaria, 243, 00199 Rome
            </div> */}
            <div className="w-full rounded-lg overflow-hidden aspect-video max-w-xs">
              <iframe
                width="100%"
                height="100%"
                src="https://maps.google.com/maps?q=Mine+IT&t=k&z=18&ie=UTF8&iwloc=&output=embed"
                frameBorder="0"
                scrolling="no"
                marginHeight="0"
                marginWidth="0"
                style={{ border: 0 }}
                title="Google Map"
                allowFullScreen
              ></iframe>
            </div>
          </div>
          {/* Right: Mail Us Form */}
          <div>
            <h2 className="text-2xl md:text-3xl font-extrabold text-[#000000] mb-4">
              You Can Mail Us
            </h2>
            <p className="text-gray-400 mb-4">
              We are always looking for a next great project.
            </p>
            <form
              onSubmit={handleContactSubmit}
              className="bg-gray-100 rounded-2xl  pt-4 pr-5 pl-5 pb-4 flex flex-col gap-10 shadow"
            >
              <div>
                <label className="block text-sm font-bold text-[#23235f] mb-1">
                  Name
                </label>
                <input
                  type="text"
                  name="name"
                  value={contactForm.name}
                  onChange={handleContactChange}
                  placeholder="Your name"
                  className="w-full rounded-lg border-2 px-4 py-2.5 text-sm resize-none focus:outline-none focus:ring-2 focus:ring-pink-200"
                  required
                />
              </div>
              <div>
                <label className="block text-sm font-bold text-[#23235f] mb-1">
                  Message
                </label>
                <textarea
                  name="message"
                  value={contactForm.message}
                  onChange={handleContactChange}
                  placeholder="Drop us a line"
                  rows={4}
                  className="w-full rounded-lg border-2 px-4 py-2.5 text-sm resize-none focus:outline-none focus:ring-2 focus:ring-pink-200"
                  required
                />
              </div>
              <div className="flex flex-col sm:flex-row items-center gap-3">
                <div className="w-full sm:w-auto flex-1">
                  <label className="block text-sm font-bold text-[#23235f] mb-1">
                    E-Mail
                  </label>
                  <input
                    type="email"
                    name="email"
                    value={contactForm.email}
                    onChange={handleContactChange}
                    placeholder="Your email"
                    className="w-full rounded-lg border-2 px-4 py-2.5 text-sm resize-none focus:outline-none focus:ring-2 focus:ring-pink-200"
                    required
                  />
                </div>
                <div className="w-full sm:w-auto">
                  {/* <button
                    type="submit"
                    className="w-32 mt-3 md:mt-3 bg-[#1de9b6] text-white font-bold px-1 py-2 rounded-full shadow hover:bg-[#13c9a7] transition-all"
                  >
                    Send
                  </button> */}
                  <Button
                    type="submit"
                    className="px-3 py-1.5  rounded-md font-semibold text-sm shadow-none min-w-0 h-9 bg-[#E08681] mt-4"
                  >
                    Send
                  </Button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-[#E08681] rounded-t-3xl pt-4 pb-4 px-4 md:px-16 mt-2">
        {/* Top Row */}
        <div className="flex flex-col md:flex-row justify-between items-center mb-4 gap-4">
          {/* <div className="text-white font-bold text-xl mb-2 md:mb-0">Logo</div>
           */}
          <img
            src={require("./dashboard/images/AECP_logo.png")}
            alt="AECP Logo"
            style={{ height: "90px", width: "auto", marginRight: "16px" }}
          />
          <div className="flex gap-8 text-white/80 text-sm">
            <a href="#" className="hover:underline text-white">
              Privacy Policy
            </a>
            <a href="#" className="hover:underline text-white">
              Terms
            </a>
          </div>
        </div>
        {/* Divider */}
        <hr className="border-t border-white/30 mb-4" />
        {/* Bottom Row */}
        <div className="flex flex-col md:flex-row justify-between items-center gap-4">
          <ul className="flex flex-wrap gap-4 md:gap-6 text-white/90 text-sm mb-2 md:mb-0">
            <li>
              <a href="#aboutus" className="hover:underline text-white">
                Home
              </a>
            </li>
            <li>
              <a href="#features" className="hover:underline text-white">
                Features
              </a>
            </li>
            <li>
              <a href="#blogs" className="hover:underline text-white">
                Blogs
              </a>
            </li>
            <li>
              <a href="#faqs" className="hover:underline text-white">
                FAQs
              </a>
            </li>
            <li>
              <a href="#contactus" className="hover:underline text-white">
                Contacts Us
              </a>
            </li>
          </ul>
          <div className="text-white/80 text-sm text-center md:text-right md:ml-12 md:mr-8">
            © {new Date().getFullYear()} MINE-IT. All rights reserved.
          </div>
        </div>
      </footer>
    </div>
  );
}